import { buildCoaching } from './coaching';
import {
  createEmptyAssessment,
  isMeaningfulFeedbackText,
  normalizeFeedbackText,
  scoreFeedbackText,
} from './scoring';

export { createEmptyAssessment, isMeaningfulFeedbackText, normalizeFeedbackText };

export function assessFeedback3d(text) {
  const assessment = scoreFeedbackText(text);
  const coaching = assessment.meta?.empty ? '' : buildCoaching(assessment);

  return {
    ...assessment,
    coaching,
    coachingPrompt: coaching,
    coachingLegacy: { coaching_prompt: coaching },
  };
}

export default assessFeedback3d;
